
































import { Component, Vue, Watch } from "vue-property-decorator";
import BaseRepository from "@/core/HttpResources/BaseRepository";
import BaseVue from "@/core/BaseVue";
import { Route } from "vue-router";
import Area from "@/models/coding/areaModel";
import FieldArea from "@/models/coding/fieldArea/fieldAreaModel";
@Component
export default class ResearchLineBase extends BaseVue {

  protected areaId: number | null = null;
  protected fieldAreaId: number | null = null;
  protected loading = false;
  protected repositoryArea!: BaseRepository<Area>;
  protected repositoryFieldArea!: BaseRepository<FieldArea>;
  protected name: any = '';
  protected modelArea: Area | any = null;
  protected modelFieldArea: FieldArea | any = null;

  created() {
    this.areaId = Number.parseInt(this.$route.params.areaId);
    this.fieldAreaId = Number.parseInt(
      this.$route.params.fieldAreaId
    );

    if (
      this.hasParent &&
      this.modelArea == null &&
      this.modelFieldArea == null
    ) {
      this.repositoryArea = new BaseRepository<Area>(
        "Areas"
      );
      this.repositoryFieldArea = new BaseRepository<Area>(
        "FieldAreas"
      );
      this.getData();
    }
  }
  get nombreArea() {
    return this.hasParent && this.modelArea
      ? this.modelArea.name
      : "---";
  }
  get nombreFieldArea() {
    return this.hasParent && this.modelFieldArea
      ? this.modelFieldArea.name
      : "---";
  }
  gotToListArea() {
    this.$router.push("/area");
  }
  gotToListFieldArea() {
    this.$router.push(`/area/${this.areaId}/fieldArea`);
  }
  protected async getData() {
    try {
      this.loading = true;
      if (this.areaId && this.fieldAreaId)
        this.modelArea = await this.repositoryArea.getById(
          this.areaId
        );
      this.modelFieldArea = await this.repositoryFieldArea.getById(
        this.fieldAreaId as any
      );
    } catch (errors) {
      this.operationFailedErrors(errors);
    } finally {
      this.loading = false;
    }
  }
  get hasParent() {
    return (
      !!this.$route.params.areaId &&
      !!this.$route.params.fieldAreaId
    );
  }
}
